import React from 'react'
import MenuItem from 'material-ui/MenuItem'

export default (resource) => [
  <MenuItem primaryText='View Run Details' key='view' value={`/write-now/comment-bots/history/${resource.id}`} />
]
